export function getPageNumbers(pageCount: number, current: number) {
  const pageNumbers: number[] = [];

  for (let i = 1; i <= Math.min(2, pageCount); i++) {
    pageNumbers.push(i);
  }

  for (let i = Math.max(1, current - 1); i < Math.min(current + 2, pageCount); i++) {
    if (!pageNumbers.includes(i)) {
      pageNumbers.push(i);
    }
  }

  for (let i = Math.max(1, pageCount - 1); i <= pageCount; i++) {
    if (!pageNumbers.includes(i)) {
      pageNumbers.push(i);
    }
  }
  return pageNumbers;
}

export function cleanUrl(baseUrl: string, queryParamName: string) {
  // Don't mind the hard coded url here, we just need it in order to parse urls that only
  // has path and search
  const url = new URL(baseUrl, 'https://stickerapp.com');
  url.searchParams.delete(queryParamName);
  return url.pathname + url.search;
}
